// extracted by mini-css-extract-plugin
module.exports = {"carouselControlPrev":"styles-module--carousel-control-prev--1iVRY","carouselControlNext":"styles-module--carousel-control-next--2LDYI"};